import UIFlex from 'UIComponents/layout/UIFlex';
import { StyledTopConnectorLine } from 'automation-ui-directed-graph/ConnectorStyledComponents';
import { getBranchTopSegmentsInfo } from 'automation-ui-directed-graph/utils/getBranchTopSegmentsInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BranchTopConnectors = ({
  currentBranchIndex,
  distanceFromMeetingPoint,
  nodeWrapperWidth,
  highlightedNodeIds,
  edges,
  meetingPointSurroundingBranches,
  getIsBranchEdgeHighlighted,
  getConnectorLineColor,
  getConnectorWidth
}) => {
  const {
    mainSegmentWidth,
    mainSegmentLeft,
    isMainSegmentHighlighted,
    otherSegmentWidth,
    otherSegmentLeft,
    isOtherSegmentHighlighted,
    connectingSegmentWidth,
    connectingSegmentLeft,
    isConnectingSegmentHighlighted
  } = getBranchTopSegmentsInfo({
    currentBranchIndex,
    distanceFromMeetingPoint,
    nodeWrapperWidth,
    edges,
    meetingPointSurroundingBranches,
    highlightedNodeIds,
    getIsBranchEdgeHighlighted
  });
  const isFirstOrLastBranch = currentBranchIndex === 0 || currentBranchIndex === edges.length - 1;
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "row",
    children: [!isFirstOrLastBranch && /*#__PURE__*/_jsx(StyledTopConnectorLine, {
      width: connectingSegmentWidth,
      left: connectingSegmentLeft,
      color: getConnectorLineColor(isConnectingSegmentHighlighted),
      edgeThickness: getConnectorWidth(isConnectingSegmentHighlighted)
    }), /*#__PURE__*/_jsx(StyledTopConnectorLine, {
      width: mainSegmentWidth,
      left: mainSegmentLeft,
      color: getConnectorLineColor(isMainSegmentHighlighted),
      edgeThickness: getConnectorWidth(isMainSegmentHighlighted)
    }), /*#__PURE__*/_jsx(StyledTopConnectorLine, {
      width: otherSegmentWidth,
      left: otherSegmentLeft,
      color: getConnectorLineColor(isOtherSegmentHighlighted),
      edgeThickness: getConnectorWidth(isOtherSegmentHighlighted)
    })]
  });
};
export default BranchTopConnectors;